import React from "react";
import "./About.css";

const About = (props) => {
  return (
    <>
      <div className="aboutContainer">
        <a rel="stylesheet" href="/about" className="aboutWrapper">
          <div className="profileImage">
            <div className="profile"></div>
          </div>
          <div className="aboutTextWrap">
            <div className="aboutText">
              <p>
                Front-End Web Developer who turns a vision into an innovation.
                Passionate at coding in React and a great sense for details.
              </p>
            </div>
            <button href="/about" className="aboutBtn">
              About!
            </button>
          </div>
        </a>
      </div>
    </>
  );
};

export default About;
